// import React, { useState } from 'react';
// import classes from './LoginPopup.module.css';
// import API_BASE_URL from '../config';

// const LoginPopup = ({ onLoginSuccess, onClose }) => {
//     const [fullName, setFullName] = useState("");
//     const [email, setEmail] = useState("");
//     const [isLoading, setIsLoading] = useState(false);
//     const [error, setError] = useState(null);

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setIsLoading(true);
//         setError(null);

//         try {
//             // Use dynamic API variable
//             const response = await fetch(`${API_BASE_URL}/api/v1/auth/login`, {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ full_name: fullName, email })
//             });

//             if (!response.ok) throw new Error("Failed to authenticate.");

//             const userData = await response.json();
//             onLoginSuccess(userData);
//         } catch (err) {
//             setError(err.message);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     return (
//         <div className={classes.overlay}>
//             <div className={classes.modal}>
//                 <button className={classes.closeBtn} onClick={onClose}>✕</button>
//                 <h2>Welcome to CHITRA</h2>
//                 <p>Please enter your details to generate your presentation.</p>

//                 {error && <div className={classes.error}>{error}</div>}

//                 <form onSubmit={handleSubmit} className={classes.form}>
//                     <input
//                         type="text"
//                         placeholder="Full Name"
//                         value={fullName}
//                         onChange={(e) => setFullName(e.target.value)}
//                         required
//                     />
//                     <input
//                         type="email"
//                         placeholder="Email Address"
//                         value={email}
//                         onChange={(e) => setEmail(e.target.value)}
//                         required
//                     />
//                     <button type="submit" disabled={isLoading}>
//                         {isLoading ? "Authenticating..." : "Continue to Generation ➔"}
//                     </button>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default LoginPopup;






import React, { useState } from 'react';
import classes from './LoginPopup.module.css';
import { chitraFetch } from './apiClient';

const LoginPopup = ({ onLoginSuccess, onClose }) => {
    // Collect both values upfront
    const [fullName, setFullName] = useState("");
    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState("");
    const [challengeId, setChallengeId] = useState(null); 
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    // Phase 1: Send the user data and request an OTP challenge string
    const handleRequestOTP = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);

        try {
            const response = await chitraFetch("/api/v1/auth/login-request", {
                method: "POST",
                body: JSON.stringify({ email: email.trim() })
            });
            const data = await response.json();
            setChallengeId(data.challenge_id); 
        } catch (err) {
            setError(err.message || "Failed to establish connect path to security backend.");
        } finally {
            setIsLoading(false);
        }
    };

    // Phase 2: Verify OTP and persist name + metadata
    const handleVerifyOTP = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);

        try {
            const response = await chitraFetch("/api/v1/auth/verify-login", {
                method: "POST",
                body: JSON.stringify({
                    email: email.trim(),
                    otp: otp.trim(),
                    challenge_id: challengeId
                })
            });

            const userData = await response.json();
            
            // Pass the verified data along with the collected name state
            onLoginSuccess({
                user_id: userData.user_id,
                email: userData.email,
                name: fullName.trim() || userData.email.split("@")[0]
            });
        } catch (err) {
            setError(err.message || "Invalid or expired authorization code.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className={classes.overlay}>
            <div className={classes.modal}>
                <button className={classes.closeBtn} onClick={onClose}>✕</button>
                <h2>Welcome to CHITRA</h2>
                <p>
                    {!challengeId 
                        ? "Enter your details to receive an access token verification code." 
                        : `Welcome ${fullName}! Enter the secure 6-digit code delivered to your account.`}
                </p>

                {error && <div className={classes.error}>{error}</div>}

                {!challengeId ? (
                    /* Phase 1: Input Name & Email */
                    <form onSubmit={handleRequestOTP} className={classes.form}>
                        <input
                            type="text"
                            placeholder="Full Name"
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                            required
                        />
                        <input
                            type="email"
                            placeholder="Email Address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        <button type="submit" disabled={isLoading}>
                            {isLoading ? "Sending Pass Code..." : "Request Login Code ➔"}
                        </button>
                    </form>
                ) : (
                    /* Phase 2: Input OTP Verification */
                    <form onSubmit={handleVerifyOTP} className={classes.form}>
                        <input
                            type="text"
                            placeholder="Enter 6-Digit OTP"
                            value={otp}
                            maxLength={6}
                            onChange={(e) => setOtp(e.target.value)}
                            required
                            style={{ textAlign: 'center', letterSpacing: '4px', fontSize: '1.2rem', fontWeight: 'bold' }}
                        />
                        <button type="submit" disabled={isLoading}>
                            {isLoading ? "Verifying..." : "Confirm & Enter Workspace ➔"}
                        </button>
                        <button 
                            type="button" 
                            style={{ background: 'transparent', border: 'none', color: '#64748b', fontSize: '0.85rem', cursor: 'pointer', marginTop: '10px' }}
                            onClick={() => setChallengeId(null)}
                        >
                            ← Modify account detail requirements
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default LoginPopup;